import { api } from "../api";

/**
 * interestPointNearVehicleExportResponse - Function that finds on database the interest points near the selected vehicle's last known position, ordered by distance, and exports in a PDF/XSLX file
 * /interest-points/{customerId}/near-vehicle/{vehicleId}/{status}/{exportType}/export
 * method GET
 * @async-function
 */
const interestPointNearVehicleExportResponse = async (
    token: string,
    customerId: number,
    vehicleId: number,
    status: string,
    exportType: string,
    maxDistanceKm?: number | null,
    simpleXlsxExport = false
) => {
    const params = new URLSearchParams();
    if (maxDistanceKm !== undefined && maxDistanceKm !== null) {
        params.set("maxDistanceKm", String(maxDistanceKm));
    }
    params.set("simple", String(simpleXlsxExport));

    const response = await api.get(
        `/interest-points/${customerId}/near-vehicle/${vehicleId}/${status}/${exportType}/export?${params.toString()}`,
        {
            responseType: "arraybuffer",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return response;
};

export default interestPointNearVehicleExportResponse;
